import { ROTATION_SNAP_ANGLE } from '../useRotationSnap';

// Fabric lands exactly on the snap point, but the angle can carry float noise
// once it has been through matrix maths.
const SNAP_EPSILON = 1e-6;

/**
 * GAPI-61780: what the rotation cue shows for a fabric angle. The angle is
 * normalised to -180..180 and rounded to one decimal, like the angle readout in
 * the properties panel; `snapped` is true only while the angle sits on a snap
 * step.
 */
function getRotationSnapCue(angle: number) {
  const normalised = ((angle % 360) + 360) % 360;
  const signed = normalised > 180 ? normalised - 360 : normalised;
  const rounded = Math.round(signed * 10) / 10;

  const snapped = Math.abs(angle - Math.round(angle / ROTATION_SNAP_ANGLE) * ROTATION_SNAP_ANGLE) < SNAP_EPSILON;

  return { angle: rounded === 0 ? 0 : rounded, snapped };
}

export default getRotationSnapCue;
